module.exports = __webpack_public_path__ + "static/CentralPerk-9fcaf99a3ac43e20587dc16263a678f7.jpg";